//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import sliderItem from '@/components/slider/slider.vue'
import sliderMarks from '@/components/slider/sliderMarks'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data () {
    return {
      rule: {
        custom: {
          validateValue: {
            required: () => '所有选项值加起来要等于比重总和'
          }
        }
      }
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    sliderItem, sliderMarks
  },
  created () {
    this.question.options.forEach(i => {
			this.$set(i, 'score', 0)
			this.$set(i, 'sliderMax', this.question.scoreTotal)
		})

		if( !this.question.v_answer ){
			this.question.v_answer = {
				tenantId: this.question.tenantId,
				type: 'proportion',
				options: []
			}
		}
		else{
			this.setValue(this.question.v_answer.options)
      this.setAnswered(true)
		}
  },
  mounted () {
    this.$validator.localize('zh_CN', this.rule);
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    validateValue () {
      if( this.question.required ){
				// 验证总和
				let isFull = this.question.scoreTotal === this.dragScoreValue
				if( !isFull && this.question.voteVisible ) {
					return ''
				}
			}
			return 'pass'
    },
    // 计算每个拖动的总和
		dragScoreValue() {
			return this.question.options.reduce((prev,cur)=>{
				return prev + cur.score
			},0)
		}
  },
  watch: {
  },
  methods: {
    // 拖动时实时函数
		onInput(value, index) {
			if( !this.question.voteVisible ){
				return false
			}
			// 为2时拖一个自动拖一个
			if( this.question.options.length === 2) {
				// index 为0时取1， 为1时取0 
				this.question.options[Number(!index)].score = this.question.scoreTotal - value
			}else{
				return false
			}
		},
		// 每一列修改
		onChange(value, index) {
      this.setAnswered(true)
			// 如果限制比重总和，需要设置其他最多能拖多少
			if( this.question.voteVisible && this.question.options.length > 2 ) {
				this.question.options.forEach(option=>{
					option.sliderMax = option.score + this.question.scoreTotal - this.dragScoreValue
				})
			}
      this.$nextTick(()=>{
				this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer: this.getValue()
        })
			})
      
		},
    // 获取值
		getValue() {
			return {
				tenantId: this.question.tenantId,
				type: 'proportion',
				options: this.question.options.map(option=>{
					return {
						tenantId: option.tenantId,
						score: option.score
					}
				})
			}
		},
    // 设置值
    setValue(answerOptions = []) {
			let maps = {}
			answerOptions.forEach(i=>{
				maps[`${i.tenantId}`] = i.score
			})
			this.question.options.forEach(i => {
				i.score = Number(maps[`${i.tenantId}`]) || 0
			})
      this.onChange()
		},
    // 设置是否已经回答
    setAnswered(status) {
      this.$store.commit('setQuestionAnswered', {
        index: this.index,
        v_answered: status
      })
    },

    validate () {
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer: this.getValue()
      })
      return this.$validator.validate()
    }
  }
}
